// Lib
import * as _ from 'lodash';
import { put, call, takeLatest, debounce } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Functions
import { parseAPIDealer, parseSingleAPIDealer } from './utils';
import { createAPINetworkInstance } from '../../../../common/api';

// Types
import { ActionGetDealerAPI, ActionGetDealerById, ActionUpdateSelectedDealerById, ActionUpdateSelectedDealerLMPackage, getDealerAPIError, getDealerAPISuccess, getDealerByIdAPIError, getDealerByIdAPISuccess, updateSelectedDealer, updateSelectedDealerSuccess, } from './actions';
import { Dealer } from './types';


function* getDealers(action: ActionGetDealerAPI) {
    try {
        const { page, limit, query, group, id } = action
        let queryStringParameter = ""
        if (query) {
            queryStringParameter = `&query=${query}`
        }
        if (group)
            queryStringParameter += `&group=${group}`
        if (id)
            queryStringParameter += `&dealer=${id}`
        const { data } = yield call(createAPINetworkInstance().get, `/dealers?page=${page}&size=${limit}${queryStringParameter}`);
        const dealers: Dealer[] = parseAPIDealer(data);
        yield put(getDealerAPISuccess(dealers, page));
    } catch (err) {
        yield put(getDealerAPIError(err));
    }
}

function* getDealerById(action: ActionGetDealerById) {
    try {
        const { dealerId } = action
        const { data } = yield call(createAPINetworkInstance().get, `/dealers/${dealerId}`);
        const dealer: Dealer = parseSingleAPIDealer(data);
        yield put(getDealerByIdAPISuccess(dealer));
    } catch (err) {
        yield put(getDealerByIdAPIError(err));
    }
}

function* updateDealerById(action: ActionUpdateSelectedDealerById) {
    try {
        const { dealerId } = action
        const { data } = yield call(createAPINetworkInstance().get, `/dealers/${dealerId}`);
        const dealer: Dealer = parseSingleAPIDealer(data);        
        yield put(updateSelectedDealerSuccess(dealer));
    } catch (err) {
        yield put(getDealerByIdAPIError(err));
    }
}

function* updateDealerLMPackage(action: ActionUpdateSelectedDealerLMPackage) {
  try {
      const { dealerId, lmPackage } = action;
      const { data } = yield call(createAPINetworkInstance().put, `/dealerlmpackage/${dealerId}/${lmPackage}`);
      const dealer: Dealer = parseSingleAPIDealer(data);        
      yield put(updateSelectedDealerSuccess(dealer));
  } catch (err) {
      yield put(getDealerByIdAPIError(err));
  }
}

export default function* dealerSagas() {
    yield debounce(300, ACTIONS.GET_DEALER_API_REQUEST, getDealers);
    yield debounce(300, ACTIONS.GET_DEALER_BY_ID_API_REQUEST, getDealerById);
    yield debounce(300, ACTIONS.UPDATE_SELECTED_DEALER, updateDealerById);
    yield debounce(300, ACTIONS.UPDATE_SELECTED_DEALER_LMPACKAGE, updateDealerLMPackage);
}
